<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("appointments/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
    appointment() {
          return this.$store.state.appointments.appointment;
      }
  },
};
</script>